import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { RequestRoot } from "types";
import { QRCodeData } from "./model/qrcode-data";
import { SubscriptionCreationData } from "./model/subscription-creation-data";
import { Department } from "./service/deptbook.service";

@Injectable()
export class AppService {
    public draft$: Subject<RequestRoot> = new Subject<RequestRoot>();
    public currentFeaturesReference: { new(): any; } | null = null;
    public qrCodeImage: QRCodeData | null = null;
    public subscriptionData: SubscriptionCreationData | null = null;
    public departments: Department[] | null = null;
}
